<form [formGroup]="newMasterclassForm" class="form">
  <div class="form-element">
    <label for="name">Nom de la formation <span class="mandatory-symbol">*</span></label>
    <input id="name" type="text" formControlName="name" />
  </div>
  <div class="form-element">
    <label for="description">Description <span class="mandatory-symbol">*</span></label>
    <textarea id="description" type="text" formControlName="description"></textarea>
  </div>
  <div class="form-element">
    <label for="speakerName">Nom de l'intervenant</label>
    <input id="speakerName" type="text" formControlName="speakerName" />
  </div>
  <div class="form-element">
    <label for="speakerPicture">Photo de l'intervenant (format png, 2:3)</label>
    <span class="speaker-picture-wrapper">
      <input #uploadFileInput id="speakerPicture" type="file" accept="*.png" (change)="onSpeakerPictureChange($event)" />
      <app-button size="sm" text="Télécharger une photo" [outlined]="true" (onClick)="uploadFileInput.click()"></app-button>
      <span class="speaker-picture-content-wrapper">
        <ng-container *ngIf="newMasterclassForm.get('speakerPicture').value !== null; else noFileSelected">
          <img src="../../../../../assets/icons/check.svg" />
          <img class="delete-picture" (click)="onSpeakerPictureChange(null)" src="../../../../../assets/icons/delete.svg" />
        </ng-container>
        <ng-template #noFileSelected>
          <span>Pas de fichier selectionné.</span>
        </ng-template>
      </span>
    </span>
  </div>
  <div class="form-element">
    <label for="category">Catégorie <span class="mandatory-symbol">*</span></label>
    <input id="category" type="text" formControlName="category" />
  </div>
  <div class="form-element">
    <label for="isAvailable">Disponible ? <span class="mandatory-symbol">*</span></label>
    <div class="checkbox-wrapper">
      <input id="isAvailable" type="checkbox" formControlName="isAvailable" />
    </div>
  </div>
  <div class="form-element">
    <label for="isBuyable">Achetable ? <span class="mandatory-symbol">*</span></label>
    <div class="checkbox-wrapper">
      <input id="isBuyable" type="checkbox" formControlName="isBuyable" />
    </div>
  </div>
  <div class="form-element">
    <label for="deliverablePrompt">Prompt du livrable</label>
    <textarea id="deliverablePrompt" formControlName="deliverablePrompt" placeholder="Prompt utilisé pour la génération du livrable final de cette formation..."></textarea>
  </div>
  <div class="variables-panel" *ngIf="data.elementInfo">
    <div class="variables-header">
      <span class="variables-title">Variables des questions</span>
      <span class="variables-actions" *ngIf="variableGroups.length">
        <span class="variables-copied" *ngIf="copiedExport">copié</span>
        <app-button size="xs" [outlined]="true" text="Copier la liste" (onClick)="copyVariablesAsList()"></app-button>
        <app-button size="xs" text="Copier en format prompt" (onClick)="copyVariablesAsPrompt()"></app-button>
      </span>
    </div>
    <ng-container *ngIf="variableGroups.length; else noVariables">
      <div class="variables-group" *ngFor="let group of variableGroups">
        <span class="variables-group-label">{{ group.moduleLabel }}</span>
        <button type="button" class="variable-row" *ngFor="let variable of group.variables" [title]="variable.courseLabel" (click)="copyVariable(variable.variable)">
          <span class="variable-question">{{ variable.question }}</span>
          <span class="variable-code-line">
            <code class="variable-code">{{ variable.variable }}</code>
            <span class="variables-copied" *ngIf="copiedVariable === variable.variable">copié</span>
          </span>
        </button>
      </div>
    </ng-container>
    <ng-template #noVariables>
      <span class="variables-empty">{{ emptyVariablesHint }}</span>
    </ng-template>
  </div>
</form>
<div class="element-form-buttons">
  <app-button [disabled]="!this.data.elementInfo" theme="danger" [outlined]="true" text="Supprimer" (click)="deleteMasterclass()"></app-button>
  <app-button [disabled]="!newMasterclassForm.valid" text="Sauvegarder" (click)="saveMasterclassWithOperation('save')"></app-button>
  <app-button [disabled]="!newMasterclassForm.valid" text="Sauvegarder et ouvrir" (click)="saveMasterclassWithOperation('open')"></app-button>
</div>
<div class="loading-layer" *ngIf="loading">
  <app-loader></app-loader>
</div>
